<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Bound",
        para: "Bound was the project from Cobold Digital. We did branding for Bound India. It was a fun project to work, that involved brainstorming sessions within the team. We tried creating branding & icons for different modules with unique vivid colors & introducing brand elements.",
        company: "Bound",
        year: "2021",
        project: "Branding",
        coverimg: "/img/gallery/ui/bound/boundcover.jpg",
        // TwoImgleft: "/img/gallery/ui/runway/2.svg",
        // TwoImgRight: "/img/gallery/ui/runway/underwork.svg",
        // ThreeImgleft: "/img/gallery/ui/runway/color.svg",
        // ThreeImgRight: "/img/gallery/ui/runway/typo.svg",
      },
    };
  },
};
</script>
